import { modularScale as scale } from 'polished';

// Configure Modular Scale to be based on the golden section and take 1em as a base;
const modularScale = steps => scale(steps, '1em', 'perfectFourth');

// Export named for automatic imports in VS Code
export { modularScale };
export default modularScale;
